export default {
  path: '/appBaseInfo',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'appBaseInfo',
  layout: 'inner', // outer 一级菜单 inner 二级菜单
  component: () => import('./index')
};
